import React, { Component, createRef } from "react";
import { currencyFormatter } from "utils/currencyHelper";
import { withNamespaces } from "react-i18next";
import "component/details/RoundDetails/styles.scss";
import { ReactComponent as CopyIcon } from "assets/icons/copy.svg";
import { copyToClipboard } from 'utils/copyToClipboard';

class RoundDetails extends Component {
  constructor(props) {
    super(props);
    this.mainRef = createRef();
    this.onCopyClickHandler = this._onCopyClickHandler.bind(this);
    this.state = {
      showToast: false,
    };
  }

  _onCopyClickHandler() {
    copyToClipboard(this.props.details.id)
      .then(() => {
        this.setState({ showToast: true });
        setTimeout(() => this.setState({ showToast: false }), 3000);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  render() {
    let { details } = this.props;
    let { t } = this.props;

    return (
      <div className="round-details" ref={this.mainRef}>
        <div className="title">{t("details")}</div>
        <div className="row">
          <div className="col">
            <table>
              <tbody>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("status")}
                    </span>
                  </th>
                  <td>
                    {details && <span>{details.status}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("roundId")}
                    </span>
                  </th>
                  <td>
                    {details && (
                      <div
                        className="copyIcon"
                        onClick={() => {
                          this.onCopyClickHandler();
                        }}
                      >
                        <span>{details.id}</span>
                        <span>
                          <CopyIcon width="25" height="25" fill="#cccc" />
                        </span>
                      </div>
                    )}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("initiated")}
                    </span>
                  </th>
                  <td>
                    {details && <span>{details.initiatedDate}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("completed")}
                    </span>
                  </th>
                  <td>
                    {details && <span>{details.completedDate}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("type")}
                    </span>
                  </th>
                  <td>
                    {details && <span>{details.type}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col">
            <table>
              <tbody>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("game")}
                    </span>
                  </th>
                  <td>
                    {details && <span>{details.gameName}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("provider")}
                    </span>
                  </th>
                  <td>
                    {details && <span>{details.provider}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("currency")}
                    </span>
                  </th>
                  <td>
                    {details && <span>{details.currency}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("roundRefId")}
                    </span>
                  </th>
                  <td>
                    {details && <span>{details.gameProviderRoundId}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col">
            <table>
              <tbody>
                {details && details.walletCurrency && (
                  <tr>
                    <th>
                      <span className={`${!details ? "dummy" : ""}`}>
                        {t("playerCurrency")}
                      </span>
                    </th>
                    <td>
                      <span>{details.walletCurrency}</span>
                    </td>
                  </tr>
                )}
                {details && details.walletConversionRate && (
                  <tr>
                    <th>
                      <span className={`${!details ? "dummy" : ""}`}>
                        {t("playerToGameFx")}
                      </span>
                    </th>
                    <td>
                      <span>{details.walletConversionRate}</span>
                    </td>
                  </tr>
                )}
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("startBalance")}
                    </span>
                  </th>
                  <td>
                    {details && (
                      <span>{`${
                        details.startBalance
                          ? currencyFormatter(details.startBalance)
                          : currencyFormatter(0)
                      }`}</span>
                    )}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("endBalance")}
                    </span>
                  </th>
                  <td>
                    {details && (
                      <span>{`${
                        details.endBalance
                          ? currencyFormatter(details.endBalance)
                          : currencyFormatter(0)
                      }`}</span>
                    )}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("totalBet")}
                    </span>
                  </th>
                  <td>
                    {details && (
                      <span>{`${currencyFormatter(details.totalBet)}`}</span>
                    )}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                {details && details.totalFreeBet && (
                  <tr>
                    <th>
                      <span className={`${!details ? "dummy" : ""}`}>
                        {t("totalFreeBet")}
                      </span>
                    </th>
                    <td>
                      <span>{`${currencyFormatter(
                        details.totalFreeBet
                      )}`}</span>
                    </td>
                  </tr>
                )}
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`}>
                      {t("totalPayout")}
                    </span>
                  </th>
                  <td>
                    {!details && <span className="dummy">loading</span>}
                    {details && (
                      <span>{`${currencyFormatter(details.totalPayout)}`}</span>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {this.props.onViewResultClick && (
          <div className="row">
            <div className="col col-12 text-center">
              {!this.props.details && (
                <button className="btn btn-lg btn-secondary btn-rnd disabled">
                  <span className="dummy">{t("viewResults")}</span>
                </button>
              )}
              {this.props.details && (
                <button
                  className="btn btn-lg btn-secondary btn-rnd"
                  onClick={() => this.props.onViewResultClick && this.props.onViewResultClick()}
                >
                  {t("viewResult")}
                </button>
              )}
            </div>
          </div>
        )}
        <div className="toast-holder d-flex justify-content-center align-items-center">
          <div className={`toast ${this.state.showToast ? "active" : ""}`}>
            <div className="toast-body">
              <strong className="mr-auto">{t("roundIdCopied")}</strong>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withNamespaces("translation")(RoundDetails);
